<template>
  <g transform="matrix(0.261866,0,0,0.261866,-3.03764,0)">
    <path d="M500.4,196L292.9,196L292.9,0L219.2,0L219.2,196L11.6,196L11.6,269.7L219.1,269.7L219.1,488.8L292.8,488.8L292.8,269.7L500.4,269.7L500.4,196Z" style="fill-rule:nonzero;"/>
  </g>
</template>